import SearchBasicListRouteFactory, {SearchBasicPageListRouteModel} from "../../search/SearchBasicPageListRouteFactory";
import {FactoryID, RouteKey} from "../../../model-factory/type-interface/ModelFactoryType";
import {MessageSearchParams} from "../../../data/subject/message/MessageDataFactory";
import {MessagePageListDataModel} from "../../../data/subject/message/MessagePageListDataFactory";
import {getModelFactory} from "../../../model-factory/ModelFactory";
import {IRouteIDs} from "../../../model-factory/type-interface/ModelFactoryInterface";
import {MessageListRouteModel} from "./MessageListRouteFactory";
import RouteModel from "../../../model-factory/basic/route/RouteModel";

export class MessagePageListRouteModel extends SearchBasicPageListRouteModel
{

    navigationRouteKey: RouteKey = "message_page_list_route_id";

    sourceDataModel:MessagePageListDataModel | null = null;
    searchParams:MessageSearchParams = new MessageSearchParams();
    noTitle:boolean = true;


    entryModel(): RouteModel | null
    {
        return getModelFactory().messageListRoute.getDefaultModel()
    }

    requireSourceDataModel(): MessagePageListDataModel | null
    {
        return getModelFactory().messagePageListData.getMessagePageListDataModel(this.searchParams);
    }
}

export default class MessagePageListRouteFactory extends SearchBasicListRouteFactory
{

    id: FactoryID = "message_page_list_route";

    birth(id: FactoryID): MessagePageListRouteModel
    {
        return new MessagePageListRouteModel(id);
    }

    getDefaultModel(): MessagePageListRouteModel
    {
        return this.getDefaultModelWithRoute()! as MessagePageListRouteModel;
    }

    defaultRouteIDs(): IRouteIDs
    {
        return {
            account_route_id : "message",
            browse_route_id : "account",
            message_route_id : "search"
        };
    }
}